"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = useUser;
var react_1 = require("react");
var context_1 = require("./context");
function useUser() {
    return (0, react_1.useContext)(context_1.UserContext);
}
//# sourceMappingURL=hook.js.map